import { apm } from '@elastic/apm-rum';
import { defaultStore, stores } from '../../translations';
import { isLocalhost } from '../is-localhost';

export const apmInit = () => {
  if (typeof window === 'undefined' || isLocalhost()) {
    return null;
  }

  const host = window.location?.host;
  const hostname = window.location?.hostname;
  const subdomain = host.split('.')[0];

  // Определяем тип окружения
  const isME = [stores.ae, stores.me, stores.qa].includes(defaultStore);
  const isCISProdHost = hostname === 'tamagotchi.goldapple.ru' || hostname === 'tamagotchi.goldapple.kz';

  let serverUrl;

  if (isME) {
    // Для ME остаёмся на старой схеме — шлём на текущий хост
    serverUrl = window.location.protocol + '//' + window.location.host;
  } else if (isCISProdHost) {
    // Явный прод СНГ
    serverUrl = 'https://sp.goldapple.ru';
  } else {
    // Всё, что не прод (test/preprod/прочее окружение) — шлём на st
    serverUrl = 'https://st.goldapple.ru';
  }

  apm.init({
    active: true,
    serviceName: 'Game_Web_Frontend_' + subdomain,
    serverUrl,
    serverUrlPrefix: '/front/api/apm/events',
    environment: window.location.host,
    monitorLongtasks: true,
    sendCredentials: true,
    transactionSampleRate: 0.1,
  });

  return apm;
};
